import React, {useContext, useEffect} from 'react';
import { logVisit } from './utils/api/reportAPI';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider, LanguageContext } from "./context/LanguageContext";

// import logo from './logo.svg';
import styles from './App.module.scss';
import './styles/App.scss';

import Header from './components/Header/Header';
import Stats from './components/Stats/Stats';
import VillageChoice from './components/VillageChoice/VillageChoice';
import GameChoice from './components/GameChoice/GameChoice';
import StartGamePage from './pages/StartGamePage/StartGamePage';
import StartTransientGame from './components/StartTransientGame/StartTransientGame';
import AdminPanelPage from './pages/AdminPanelPage/AdminPanelPage';
import HomePage from './pages/HomePage/HomePage';
import ResetRequestPage from './pages/ResetRequestPage/ResetRequestPage';
import ResetPasswordPage from './pages/ResetPasswordPage/ResetPasswordPage';
import UserPanelPage from './pages/UserPanelPage/UserPanelPage';
import PartnerPanelPage from './pages/PartnerPanelPage/PartnerPanelPage';
import MentionsLegalesPage from './pages/MentionsLegalesPage/MentionsLegalesPage';
import MentionsLegalesPage_En from './pages/MentionsLegalesPage/MentionsLegalesPage_En';
import MentionsLegalesPage_Es from './pages/MentionsLegalesPage/MentionsLegalesPage_Es';
import MentionsLegalesPage_De from './pages/MentionsLegalesPage/MentionsLegalesPage_De';
import MentionsLegalesPage_It from './pages/MentionsLegalesPage/MentionsLegalesPage_It';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage/PrivacyPolicyPage';
import PrivacyPolicyPage_En from './pages/PrivacyPolicyPage/PrivacyPolicyPage_En';
import PrivacyPolicyPage_Es from './pages/PrivacyPolicyPage/PrivacyPolicyPage_Es';
import PrivacyPolicyPage_De from './pages/PrivacyPolicyPage/PrivacyPolicyPage_De';
import PrivacyPolicyPage_It from './pages/PrivacyPolicyPage/PrivacyPolicyPage_It';
import ConditionsUtilisationPage from './pages/ConditionsUtilisationPage/ConditionsUtilisationPage';
import ConditionsUtilisationPage_En from './pages/ConditionsUtilisationPage/ConditionsUtilisationPage_En';
import ConditionsUtilisationPage_Es from './pages/ConditionsUtilisationPage/ConditionsUtilisationPage_Es';
import ConditionsUtilisationPage_De from './pages/ConditionsUtilisationPage/ConditionsUtilisationPage_De';
import ConditionsUtilisationPage_It from './pages/ConditionsUtilisationPage/ConditionsUtilisationPage_It';
import ContactPage from './pages/ContactPage/ContactPage';
// import UserForm from './components/UserForm/UserForm';
import ProtectedRoute from './routes/ProtectedRoute';
import AdminRoute from './routes/AdminRoute';
import LogoutRoute from './routes/LogoutRoute';
import PartnerRoute from './routes/PartnerRoute';

import { Workbox } from 'workbox-window';

if ('serviceWorker' in navigator) {
  const wb = new Workbox('/service-worker.js');
  wb.register();
}

// Composant pour gérer dynamiquement la page des Conditions d'Utilisation
const DynamicConditionsPage = () => {
  const { language } = useContext(LanguageContext);

  switch (language) {
    case 'en':
      return <ConditionsUtilisationPage_En />;
    case 'es':
      return <ConditionsUtilisationPage_Es />;
    case 'de':
      return <ConditionsUtilisationPage_De />;
    case 'it':
      return <ConditionsUtilisationPage_It />;
    default:
      return <ConditionsUtilisationPage />;
  }
};

// Composant pour gérer dynamiquement la page des Conditions d'Utilisation
const DynamicPrivacyPage = () => {
  const { language } = useContext(LanguageContext);

  switch (language) {
    case 'en':
      return <PrivacyPolicyPage_En />;
    case 'es':
      return <PrivacyPolicyPage_Es />;
    case 'de':
      return <PrivacyPolicyPage_De />;
    case 'it':
      return <PrivacyPolicyPage_It />;
    default:
      return <PrivacyPolicyPage />;
  }
};

// Composant pour gérer dynamiquement la page des Conditions d'Utilisation
const DynamicLegalPage = () => {
  const { language } = useContext(LanguageContext);

  switch (language) {
    case 'en':
      return <MentionsLegalesPage_En />;
    case 'es':
      return <MentionsLegalesPage_Es />;
    case 'de':
      return <MentionsLegalesPage_De />;
    case 'it':
      return <MentionsLegalesPage_It />;
    default:
      return <MentionsLegalesPage />;
  }
};


function App() {

  useEffect(() => {
    logVisit();
  }, []);

  return (
    <Router>
      <AuthProvider>
        <LanguageProvider>
          <div className={styles.app}>
            <Header />
            <section className={styles.page}>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/choix-village" element={<ProtectedRoute component={VillageChoice} />} />
                  <Route path="/independant-game" element={<ProtectedRoute component={GameChoice} />} />
                  <Route path="/start-game" element={<ProtectedRoute component={StartGamePage} />} />
                  <Route path="/load-game" element={<ProtectedRoute component={StartTransientGame} />} /> {/* Changer pour ProtectedRoute quand OK */}
                  <Route path="/user-account" element={<ProtectedRoute component={UserPanelPage} />} />
                  <Route path="/partner-panel" element={<PartnerRoute component={PartnerPanelPage} />} />
                  <Route path="/admin-panel" element={<AdminRoute component={AdminPanelPage} />} />
                  <Route path="/logout" element={<LogoutRoute />} />
                  <Route path="/login" element={<ProtectedRoute component={HomePage} />} />
                  <Route path="/reset-request" element={<ResetRequestPage />} />
                  <Route path="/reset-password" element={<ResetPasswordPage />} />
                  <Route path="/conditions" element={<DynamicConditionsPage />} />
                  <Route path="/privacy" element={<DynamicPrivacyPage />} />
                  <Route path="/legal" element={<DynamicLegalPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/admin-stats" element={<Stats />} />
                </Routes>
            </section>
          </div>
        </LanguageProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
